
function pad(number, length) {
    var str = '' + number;
    while (str.length < length) {
        str = '0' + str;
    }
    return str;
}

function formatLocalDate(date) {
    var tzo = -date.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function (num) {
            var norm = Math.abs(Math.floor(num));
            return (norm < 10 ? '0' : '') + norm;
        };
    return date.getFullYear()
        + '-' + pad(date.getMonth() + 1)
        + '-' + pad(date.getDate())
        + 'T' + pad(date.getHours())
        + ':' + pad(date.getMinutes())
        + ':' + pad(date.getSeconds())
        + dif + pad(tzo / 60)
        + ':' + pad(tzo % 60);
};

// retorna un Date para el día de hoy, sin hora (a las 00:00:00)
function today() {
    var date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function timeStringToDate(time) {
    if (time) {
        var times = time.split(':');
        if (times.length === 2) {
            return new Date(1970, 1, 1, parseInt(times[0]), parseInt(times[1]), 0, 0);
        }
        return new Date(1970, 1, 1, parseInt(times[0]), parseInt(times[1]), parseInt(times[2]), 0);
    }
    return null;
}

function dateToTimeString(date, ignoreSeconds) {
    if (!date)
        return '';
    if (ignoreSeconds)
        return ('00' + date.getHours()).slice(-2) + ':' + ('00' + date.getMinutes()).slice(-2);
    else
        return ('00' + date.getHours()).slice(-2) + ':' + ('00' + date.getMinutes()).slice(-2) + ':' + ('00' + date.getSeconds()).slice(-2);
}

function convertUTCDateToLocalDate(date) {
    newDate = new Date();
    newDate.setTime(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    return newDate;
}

function convertLocalDateToUTCDate(date) {
    newDate = new Date();
    newDate.setTime(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
    return newDate;
}
